"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThrottleAsyncExecutor = void 0;
const queue_1 = require("../common/data-stractures/queue");
class ThrottleAsyncExecutor {
    constructor(fun, parallelCalls) {
        this.fun = fun;
        this.parallelCalls = parallelCalls;
        this.onGoingCallsCount = 0;
        this.callsToRun = new queue_1.Queue();
    }
    exec(context, args) {
        const callArgs = { context, args, resolve: null, reject: null };
        this.callsToRun.enqueue(callArgs);
        const proms = new Promise((resolve, reject) => {
            callArgs.resolve = resolve;
            callArgs.reject = reject;
        });
        this.tryCall();
        proms.hell = args[0];
        return proms;
    }
    tryCall() {
        if (this.callsToRun.getSize() > 0 && this.onGoingCallsCount < this.parallelCalls) {
            const { context, args, resolve, reject } = this.callsToRun.dequeue();
            this.onGoingCallsCount += 1;
            this.fun.apply(context, args)
                .then(resolve)
                .catch(reject)
                .finally(() => {
                this.onGoingCallsCount -= 1;
                this.tryCall();
            });
        }
    }
}
exports.ThrottleAsyncExecutor = ThrottleAsyncExecutor;
